import React from 'react';
import HeroSection from './sections/HeroSection';
import AboutImwEduSection from './sections/AboutImwEduSection';
import IconBoxesSection from './sections/IconBoxesSection';
import QualityStatsSection from './sections/QualityStatsSection';
import MissionSection from './sections/MissionSection';
import VisionSection from './sections/VisionSection';
import FeePaymentSection from './sections/FeePaymentSection';
import ContactUsSectionMap from './sections/ContactUsSectionMap';
// ... import other sections

const MainContent = ({ addToCart }) => { // Pass addToCart if any section needs it
  return (
    <div className="wd-page-content main-page-wrapper">
      <main className="wd-content-layout content-layout-wrapper container" role="main">
        <div className="wd-content-area site-content">
          <article id="post-13" className="entry-content post-13 page type-page status-publish hentry">
            <div data-elementor-type="wp-page" data-elementor-id="13" className="elementor elementor-13">
              <HeroSection />
              <AboutImwEduSection />
              <IconBoxesSection />
              <QualityStatsSection />
              <MissionSection />
              <VisionSection />
              <FeePaymentSection />
              <ContactUsSectionMap />
              {/* Add other sections here */}
            </div>
          </article>
        </div>
      </main>
    </div>
  );
};

export default MainContent;